import { useTranslation } from 'react-i18next';
import { SEO } from '../components/SEO';

export const PrivacyPolicy = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen pt-16 bg-white" style={{fontFamily:'IBM Plex Sans,sans-serif'}}>
      <SEO title={`${t('privacy.title')} | Durable Designs`} description={t('privacy.title')} path="/privacy-policy" />

      <section className="bg-green-900 py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-[640px] mx-auto">
          <h1 className="text-4xl sm:text-5xl font-semibold text-white tracking-tight" style={{fontFamily:'Outfit,sans-serif'}} data-testid="privacy-heading">
            {t('privacy.title')}
          </h1>
          <p className="text-sm text-green-300 mt-3">{t('privacy.last_updated')}</p>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-[640px] mx-auto prose-dd">

          <p>{t('privacy.intro_p1')}</p>
          <p>{t('privacy.intro_p2')}</p>
          <ul>
            <li>{t('privacy.intro_li1')}</li>
            <li>{t('privacy.intro_li2')}</li>
            <li>{t('privacy.intro_li3')}</li>
          </ul>
          <p>{t('privacy.intro_p3')}</p>
          <p className="not-italic" data-testid="privacy-data-controller"><strong>{t('privacy.intro_p4')}</strong></p>

          {/* Section 1 */}
          <h2>{t('privacy.s1_title')}</h2>
          <p>{t('privacy.s1_p1')}</p>
          <ul>
            <li><strong>Identification and contact information:</strong> {t('privacy.s1_li1').replace('Identification and contact information: ','')}</li>
            <li><strong>Message content:</strong> {t('privacy.s1_li2').replace('Message content: ','')}</li>
            <li><strong>Technical data:</strong> {t('privacy.s1_li3').replace('Technical data: ','')}</li>
            <li><strong>Usage data for engineering tools:</strong> {t('privacy.s1_li4').replace('Usage data for engineering tools: ','')}</li>
          </ul>
          <p>{t('privacy.s1_p2')}</p>

          {/* Section 2 */}
          <h2>{t('privacy.s2_title')}</h2>
          <p>{t('privacy.s2_p1')}</p>
          <ul>
            <li><strong>Consent</strong> (Art. 6(1)(a) EU/UK GDPR): {t('privacy.s2_li1').split(': ').slice(1).join(': ')}</li>
            <li><strong>Legitimate interests</strong> (Art. 6(1)(f) EU/UK GDPR): {t('privacy.s2_li2').split(': ').slice(1).join(': ')}</li>
            <li><strong>Legal obligations</strong> (Art. 6(1)(c) EU/UK GDPR): {t('privacy.s2_li3').split(': ').slice(1).join(': ')}</li>
          </ul>
          <p>{t('privacy.s2_p2')}</p>
          <ul>
            <li>{t('privacy.s2_li4')}</li>
            <li>{t('privacy.s2_li5')}</li>
          </ul>
          <p>{t('privacy.s2_p3')}</p>

          {/* Section 3 */}
          <h2>{t('privacy.s3_title')}</h2>
          <p>{t('privacy.s3_p1')}</p>
          <ul>
            <li>{t('privacy.s3_li1')}</li>
            <li>{t('privacy.s3_li2')}</li>
            <li>{t('privacy.s3_li3')}</li>
            <li>{t('privacy.s3_li4')}</li>
            <li>{t('privacy.s3_li5')}</li>
          </ul>
          <p>{t('privacy.s3_p2')}</p>

          {/* Section 4 */}
          <h2>{t('privacy.s4_title')}</h2>
          <p>{t('privacy.s4_p1')}</p>
          <p>{t('privacy.s4_p2')}</p>
          <div className="overflow-x-auto">
            <table>
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Provider</th>
                  <th>Purpose</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>{t('privacy.s4_r1_cat')}</strong></td>
                  <td>{t('privacy.s4_r1_eg')}</td>
                  <td>{t('privacy.s4_r1_purpose')}</td>
                </tr>
                <tr>
                  <td><strong>{t('privacy.s4_r2_cat')}</strong></td>
                  <td>{t('privacy.s4_r2_eg')}</td>
                  <td>{t('privacy.s4_r2_purpose')}</td>
                </tr>
                <tr>
                  <td><strong>{t('privacy.s4_r3_cat')}</strong></td>
                  <td>{t('privacy.s4_r3_eg')}</td>
                  <td>{t('privacy.s4_r3_purpose')}</td>
                </tr>
                <tr>
                  <td><strong>{t('privacy.s4_r4_cat')}</strong></td>
                  <td>{t('privacy.s4_r4_eg')}</td>
                  <td>{t('privacy.s4_r4_purpose')}</td>
                </tr>
                <tr>
                  <td><strong>{t('privacy.s4_r5_cat')}</strong></td>
                  <td>{t('privacy.s4_r5_eg')}</td>
                  <td>{t('privacy.s4_r5_purpose')}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>{t('privacy.s4_p3')}</p>
          <p>{t('privacy.s4_p4')}</p>

          {/* Section 5 */}
          <h2>{t('privacy.s5_title')}</h2>
          <p>{t('privacy.s5_p1')}</p>
          <ul>
            <li>{t('privacy.s5_li1')}</li>
            <li>{t('privacy.s5_li2')}</li>
            <li>{t('privacy.s5_li3')}</li>
            <li>{t('privacy.s5_li4')}</li>
          </ul>
          <p>{t('privacy.s5_p2')}</p>

          {/* Section 6 */}
          <h2>{t('privacy.s6_title')}</h2>
          <p>{t('privacy.s6_p1')}</p>
          <ul>
            <li><strong>Right of access:</strong> {t('privacy.s6_li1').replace('Right of access: ','')}</li>
            <li><strong>Right to rectification:</strong> {t('privacy.s6_li2').replace('Right to rectification: ','')}</li>
            <li><strong>Right to erasure:</strong> {t('privacy.s6_li3').replace('Right to erasure: ','')}</li>
            <li><strong>Right to restriction of processing:</strong> {t('privacy.s6_li4').replace('Right to restriction of processing: ','')}</li>
            <li><strong>Right to object:</strong> {t('privacy.s6_li5').replace('Right to object: ','')}</li>
            <li><strong>Right to data portability:</strong> {t('privacy.s6_li6').replace('Right to data portability: ','')}</li>
            <li><strong>Right to withdraw consent:</strong> {t('privacy.s6_li7').replace('Right to withdraw consent: ','')}</li>
          </ul>
          <p>{t('privacy.s6_contact')} <a href="mailto:info@durabledesigns.co.uk" className="text-green-700 hover:text-green-600">info@durabledesigns.co.uk</a></p>
          <p>{t('privacy.s6_complaint_p1')}</p>
          <ul>
            <li>{t('privacy.s6_complaint_li1')}</li>
            <li>{t('privacy.s6_complaint_li2')} <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer" className="text-green-700 hover:text-green-600">ico.org.uk</a></li>
          </ul>

          {/* Section 7 */}
          <h2>{t('privacy.s7_title')}</h2>
          <p>{t('privacy.s7_p1')}</p>
          <ul>
            <li>{t('privacy.s7_li1')}</li>
            <li>{t('privacy.s7_li2')}</li>
          </ul>
          <p>{t('privacy.s7_contact')} <a href="mailto:info@durabledesigns.co.uk" className="text-green-700 hover:text-green-600">info@durabledesigns.co.uk</a></p>
          <p>{t('privacy.s7_p2')}</p>

          {/* Section 8 */}
          <h2>{t('privacy.s8_title')}</h2>
          <p>{t('privacy.s8_p1')}</p>
          <p>{t('privacy.s8_p2')}</p>
          <ul>
            <li>{t('privacy.s8_li1')}</li>
            <li>{t('privacy.s8_li2')}</li>
            <li>{t('privacy.s8_li3')}</li>
            <li>{t('privacy.s8_li4')}</li>
          </ul>
          <p>{t('privacy.s8_p3')}</p>

          {/* Section 9 */}
          <h2>{t('privacy.s9_title')}</h2>
          <p>{t('privacy.s9_p1')}</p>
          <p>{t('privacy.s9_p2')}</p>
          <ul>
            <li>{t('privacy.s9_li1')}</li>
            <li>{t('privacy.s9_li2')}</li>
            <li>{t('privacy.s9_li3')}</li>
          </ul>
          <p>{t('privacy.s9_p3')}</p>

          {/* Section 10 */}
          <h2>{t('privacy.s10_title')}</h2>
          <p>{t('privacy.s10_p1')}</p>
          <p>{t('privacy.s10_p2')}</p>
          <ul>
            <li>{t('privacy.s10_li1')}</li>
            <li>{t('privacy.s10_li2')}</li>
            <li>{t('privacy.s10_li3')}</li>
          </ul>
          <p>{t('privacy.s10_p3')}</p>

          {/* Section 11 */}
          <h2>{t('privacy.s11_title')}</h2>
          <p>{t('privacy.s11_p1')}</p>
          <p>{t('privacy.s11_p2')}</p>
          <ul>
            <li>{t('privacy.s11_li1')}</li>
            <li>{t('privacy.s11_li2')}</li>
          </ul>
          <p>{t('privacy.s11_p3')}</p>

          {/* Section 12 */}
          <h2>{t('privacy.s12_title')}</h2>
          <p>{t('privacy.s12_p1')}</p>
          <ul>
            <li><strong>Essential purposes:</strong> {t('privacy.s12_li1').replace('Essential purposes: ','')}</li>
            <li><strong>Preferences:</strong> {t('privacy.s12_li2').replace('Preferences: ','')}</li>
            <li><strong>Analytics:</strong> {t('privacy.s12_li3').replace('Analytics: ','')}</li>
          </ul>
          <p>{t('privacy.s12_p2')}</p>

          {/* Section 13 */}
          <h2>{t('privacy.s13_title')}</h2>
          <p>{t('privacy.s13_p1')}</p>
          <ul>
            <li>{t('privacy.s13_li1')}</li>
            <li>{t('privacy.s13_li2')}</li>
            <li>{t('privacy.s13_li3')}</li>
            <li>{t('privacy.s13_li4')}</li>
          </ul>
          <p>{t('privacy.s13_p2')}</p>

          {/* Section 14 */}
          <h2>{t('privacy.s14_title')}</h2>
          <p>{t('privacy.s14_p1')}</p>
          <p>{t('privacy.s14_p2')}</p>
          <p>{t('privacy.s14_p3')}</p>

          {/* Section 15 */}
          <h2>{t('privacy.s15_title')}</h2>
          <p>{t('privacy.s15_p1')}</p>
          <ul>
            <li>{t('privacy.s15_li1')}</li>
            <li>{t('privacy.s15_li2')}</li>
            <li>{t('privacy.s15_li3')}</li>
          </ul>
          <p>{t('privacy.s15_p2')}</p>

          {/* Section 16 */}
          <h2>{t('privacy.s16_title')}</h2>
          <p>{t('privacy.s16_p1')}</p>
          <p>{t('privacy.s16_p2')}</p>

          {/* Section 17 */}
          <h2>{t('privacy.s17_title')}</h2>
          <p data-testid="privacy-contact-block">
            {t('privacy.s17_company')}<br />
            {t('privacy.s17_address_label')} {t('privacy.s17_address')}<br />
            Email: <a href="mailto:info@durabledesigns.co.uk" className="text-green-700 hover:text-green-600">info@durabledesigns.co.uk</a><br />
            Website: <a href="https://durabledesigns.co.uk" target="_blank" rel="noopener noreferrer" className="text-green-700 hover:text-green-600">durabledesigns.co.uk</a>
          </p>

        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
